import { CSSProperties } from 'react';

import { Alert } from 'antd';
import { T } from 'react-translator-component';

type ReadOnlyAlertProps = {
  style?: CSSProperties;
};

/**
 * Aviso de somente leitura das telas de perfil de preço. Compartilhado entre o
 * detalhe do perfil e a tela de preços para o texto não divergir entre elas.
 */
export const ReadOnlyAlert = ({ style }: ReadOnlyAlertProps) => (
  <Alert
    message={T('Read only — this profile is not available for editing.')}
    showIcon
    style={style}
    type='info'
  />
);
